import { COMPANY_API } from 'apis';

const getClientContractDetail = async (clientContractIdx: string | number) => {
  const result = await COMPANY_API.get(`/finance/client-contracts/${clientContractIdx}`);
  return result.data;
};

export default getClientContractDetail;
